import React from 'react';
import classNames from 'classnames';

import { builderDispatch } from '../_utils/ui';
import CartItemsChangeEvents from './cart-items-change-events';
import genericHelpers from '../_utils/generic-helpers';
import LocationFormatter from './location-formatter';
import { default as WebKiosk } from '../_utils/tools/store';

// -----------------------------------------------------------
//  Store
// -----------------------------------------------------------
const Store = props => {
  const { selected, unavailableItems = [] } = props;

  const {
    id,
    name,
    storeType,
    address: { street, city, state, zipcode },
    distance,
    pickupTimes,
  } = new LocationFormatter(props.store);

  const address = [
    genericHelpers.capitalizeWordsInString(storeType),
    street,
    [city, [state, zipcode].filter(Boolean).join(' ')].join(', '),
  ].filter(Boolean);

  var ariaLabel = `Store ${name}`;
  if(selected) {
    ariaLabel += " (currently selected)";
  }

  return (
    <tr
      className={classNames('store-locator-list-item', { selected })}
      onClick={!selected ? updatePreferredStore : null}>
      <td className="store-selection">
        <input type="radio" readOnly
               value={id} checked={selected}
               aria-label={ariaLabel} />
      </td>
      <td className="store-details">
        <span className="store-name">
          <strong>{name}</strong>
        </span>{' '}
        {WebKiosk.isWalmart() && (
          <span className="store-number">
            <strong>#{id}</strong>
          </span>
        )}
        <br />
        {address.map((line, i) => {
          return (
            <span key={i} className="store-address">
              {line}
              <br />
            </span>
          );
        })}
      </td>
      <td className="store-distance">
        <span>{distance.miles} mi.</span>
      </td>
      <td>
        {pickupTimes.map((pickupMsg, i) => (
          <div className="alert store-order-timestamps" key={`msg-${i}`}>
            {pickupMsg}
            <br />
          </div>
        ))}
        {unavailableItems.map((item, i) => (
          <div
            key={`${i}-${item.storeId}`}
            className="alert alert-warning store-order-message">
            {item.message.short}
            <br />
          </div>
        ))}
      </td>
    </tr>
  );

  function updatePreferredStore(e) {
    e.stopPropagation();

    builderDispatch.dispatch({
      type: CartItemsChangeEvents.PICKUP_LOCATION_CHANGE,
      value: props.store.id,
    });
  }
};

export default Store;
